/* global gsap */
const shineBtn = document.querySelectorAll('[data-ref="btn-shine"]');
const gradientBtn = document.querySelectorAll('[data-ref="btn-gradient"]');
const hotFireBtn = document.querySelectorAll('[data-ref="btn-hot-fire"]');

const mm = gsap.matchMedia();
const breakPoint = 800;

// Shine effect
gsap.utils.toArray('[data-ref="shine-parent"]').forEach((parent)=> {
  mm.add(`(min-width: ${breakPoint}px)`, (context) => {
    const gradient = parent.querySelector('[data-ref="type-shine"]');
    let solidColor = '#000';

    if (gradient) {
      if (gradient.classList.contains('type-shine-light')) {
        solidColor = '#FFF';
      }

      context.add('onMouseMove', (event) => {
        const xyData = handleShineTypeMovement(event, parent, gradient);

        gsap.to(gradient, {
          backgroundImage: `radial-gradient(circle at ${xyData.x}% ${xyData.y}%, #00c290 0%, #A9F2A3 25%, #FFC022 50%, #FF4D24 75%, ${solidColor} 100%)`,
        });
      });

      parent.addEventListener('mousemove', context.onMouseMove);
    }

    return () => {
      parent.removeEventListener('mousemove', context.onMouseMove);
    };
  });
});

// Fire effect
gsap.utils.toArray('[data-ref="fire-parent"]').forEach((parent)=> {
  mm.add(`(min-width: ${breakPoint}px)`, (context) => {
    const gradient = parent.querySelector('[data-ref="type-fire"]');
    let solidColor = '#000';

    if (gradient) {
      if (gradient.classList.contains('type-fire-light')) {
        solidColor = '#FFF';
      }

      context.add('onMouseMove', (event) => {
        const xyData = handleShineTypeMovement(event, parent, gradient);

        gsap.to(gradient, {
          backgroundImage: `radial-gradient(circle at ${xyData.x}% ${xyData.y}%, #FFD700 0%, #FFA500 20%, #FF4500 40%, #8B0000 60%, ${solidColor} 100%)`,
        });
      });

      parent.addEventListener('mousemove', context.onMouseMove);
    }

    return () => {
      parent.removeEventListener('mousemove', context.onMouseMove);
    };
  });
});

// Mobile shine effect
gsap.utils.toArray('[data-ref="shine-parent"]').forEach((parent)=> {
  mm.add(`(max-width: ${breakPoint - 1}px)`, () => {
    const gradient = parent.querySelector('[data-ref="type-shine"]');
    let solidColor = '#000';

    if (gradient) {
      if (gradient.classList.contains('type-shine-light')) {
        solidColor = '#FFF';
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: parent,
          scrub: 1,
          start: 'top center',
          end: 'top top',
          toggleActions: 'restart pause resume pause',
          refreshPriority: 1,
        },
      });

      gsap.set(gradient, {
        backgroundImage: `radial-gradient(circle at -50% 50%, #00c290 0%, #A9F2A3 25%, #FFC022 50%, #FF4D24 75%, ${solidColor} 100%)`,
      });

      tl.to(gradient, {
        backgroundImage: `radial-gradient(circle at 150% 50%, #00c290 0%, #A9F2A3 25%, #FFC022 50%, #FF4D24 75%, ${solidColor} 100%)`,
      });
    }
    return () => {
      gsap.set(gradient, {
        backgroundImage: `radial-gradient(circle at -50% 50%, #00c290 0%, #A9F2A3 25%, #FFC022 50%, #FF4D24 75%, ${solidColor} 100%)`,
      });
    };
  });
});

// Mobile fire effect
gsap.utils.toArray('[data-ref="fire-parent"]').forEach((parent)=> {
  mm.add(`(max-width: ${breakPoint - 1}px)`, () => {
    const gradient = parent.querySelector('[data-ref="type-fire"]');
    let solidColor = '#000';

    if (gradient) {
      if (gradient.classList.contains('type-fire-light')) {
        solidColor = '#FFF';
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: parent,
          scrub: 1,
          start: 'top center',
          end: 'top top',
          toggleActions: 'restart pause resume pause',
          refreshPriority: 1,
        },
      });

      gsap.set(gradient, {
        backgroundImage: `radial-gradient(circle at -50% 50%, #FFD700 0%, #FFA500 20%, #FF4500 40%, #8B0000 60%, ${solidColor} 100%)`,
      });

      tl.to(gradient, {
        backgroundImage: `radial-gradient(circle at 150% 50%, #FFD700 0%, #FFA500 20%, #FF4500 40%, #8B0000 60%, ${solidColor} 100%)`,
      });
    }
    return () => {
      gsap.set(gradient, {
        backgroundImage: `radial-gradient(circle at -50% 50%, #FFD700 0%, #FFA500 20%, #FF4500 40%, #8B0000 60%, ${solidColor} 100%)`,
      });
    };
  });
});

const handleShineTypeMovement = (event, parent, gradient) => {
  // Calculate the mouse position relative to the gradient object
  const x = event.clientX - gradient.getBoundingClientRect().left;
  const y = event.clientY - gradient.getBoundingClientRect().top;

  // Calculate the percentage of mouse placement vs the gradients width and height
  const xPercValue = (x / gradient.offsetWidth) * 100;
  const yPercValue = (y / gradient.offsetHeight) * 100;

  return {
    x: xPercValue,
    y: yPercValue,
  };
};

if (shineBtn && shineBtn.length > 0) {
  shineBtn.forEach((btn) => {
    btn.addEventListener('mousemove', function(event) {
      const {x} = btn.getBoundingClientRect();

      const xPercent = Math.round(((event.clientX - parseInt(x)) / btn.offsetWidth) * 100);

      gsap.to(btn, {
        backgroundImage: `linear-gradient(90deg, #00c290 ${xPercent - 80}%, #A9F2A3 ${xPercent - 40}%, #FFC022 ${xPercent + 20}%, #FF4D24 ${xPercent + 80}%)`,
        duration: 0.3,
      });
    });
  });
}

if (gradientBtn && gradientBtn.length > 0) {
  gradientBtn.forEach((btn) => {
    let solidColor = '#000';

    if (btn.classList.contains('btn--gradient--dark')) {
      solidColor = '#EEE';
    }

    btn.addEventListener('mouseover', function() {
      gsap.to(btn, {
        backgroundImage: `linear-gradient(90deg, ${solidColor} -100%, ${solidColor} 0%, #00c290 0%, #A9F2A3 30%, #FFC022 60%, #FF4D24 100%)`,
        duration: 0.3,
      });
    });

    btn.addEventListener('mouseout', function() {
      gsap.to(btn, {
        backgroundImage: `linear-gradient(90deg, ${solidColor} 0%, ${solidColor} 100%, #00c290 100%, #A9F2A3 170%, #FFC022 202%, #FF4D24 224%)`,
        duration: 0.3,
      });
    });
  });
}

if (hotFireBtn && hotFireBtn.length > 0) {
  hotFireBtn.forEach((btn) => {
    btn.addEventListener('mousemove', function(event) {
      const {x} = btn.getBoundingClientRect();

      const xPercent = Math.round(((event.clientX - parseInt(x)) / btn.offsetWidth) * 100);

      gsap.to(btn, {
        backgroundImage: `linear-gradient(90deg, #FFD700 ${xPercent - 80}%, #FFA500 ${xPercent - 40}%, #FF6A00 ${xPercent + 20}%, #FF2400 ${xPercent + 80}%)`,
        duration: 0.3,
      });
    });
  });
}

// Targeting first item in page for certain modules
const loadTypeReveal = document.querySelector('[data-element="type-shine-load"]');

if (loadTypeReveal) {
  let solidColor = '#000';

  if (loadTypeReveal.classList.contains('type-shine-light')) {
    solidColor = '#FFF';
  }

  const tl = gsap.timeline();

  tl.to(loadTypeReveal, {
    backgroundImage: `linear-gradient(95deg, ${solidColor} -100%, #00c290 -41%, #A9F2A3 28%, #FFC022 112%, ${solidColor} 200%)`,
    ease: 'power3.inOut',
    duration: 0.75,
  }).to(loadTypeReveal, {
    backgroundImage: `linear-gradient(95deg, ${solidColor} -100%, #00c290 -41%, #A9F2A3 -28%, #FFC022 -112%, ${solidColor} 0%)`,
    ease: 'power3.inOut',
    duration: 0.75,
  }, '<75%');
}
